import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  font-family: Spoqa Han Sans Neo;
`;

const SimpleInfoBox = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 6px;
  background: rgba(0, 138, 255, 0.06);
`;

const Dot = styled.div`
  width: 6px;
  height: 6px;
  aspect-ratio: 1/1;
  background-color: #008aff;
  border-radius: 9999px;
`;

const SimpleInfoDivider = styled.div`
  width: 1px;
  height: 8px;
  background-color: #e1e2e4;
`;

const SimpleInfoText = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;
const SummaryBox = styled.div`
  display: flex;
  padding: 16px 16px 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const SummaryDetail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

const TitleArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const TitleAreaTop = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const ItemTypeChip = styled.div<{ type?: string }>`
  padding: 2px 8px;
  border-radius: 4px;
  background: ${({ type }) => (type === 'a' ? '#008aff' : '#F04452')};
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;

const TitleAreaTopButtonBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ButtonIcon = styled.button`
  border: none;
  background-color: transparent;
  display: flex;
  width: 36px;
  height: 36px;
  justify-content: center;
  align-items: center;
`;

const Address = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
`;

const AddressDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
  color: rgba(55, 56, 60, 0.61);
`;

const CopyAddress = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  color: #008aff;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;

const RowDivider = styled.div`
  height: 1px;
  width: 100%;
  background: rgba(112, 115, 124, 0.16);
`;

const DetailArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InfoArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const InfoList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const Info = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const InfoText = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
  color: #222;
`;

const PriceAreaInfoText = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
  color: #616161;
`;

const ChangeUnitButton = styled.button`
  display: flex;
  padding: 2px 4px;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border-radius: 4px;
  border: 1px solid #e5e8ea;
  background: #fff;

  color: #616161;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

const InfoDateBox = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const DDayBadge = styled.div`
  display: flex;
  padding: 1px 6px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #616161;

  color: #fff;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 15.95px */
  letter-spacing: -0.22px;
`;

const PriceArea = styled.div`
  width: 100%;
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 8px;
  border-radius: 12px;
  background: #f7f8fc;
`;

const PriceText = styled.div<{ isEmpty?: boolean }>`
  color: ${({ isEmpty }) => (isEmpty ? '#0019364F' : '#222')};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: ${({ isEmpty }) => (isEmpty ? '500' : '700')};
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;

const MinimumPriceInfoText = styled(InfoText)`
  gap: 4px;
  color: #008aff;
`;

const BidPriceInfoText = styled(InfoText)`
  color: #f04452;
`;

const MinimumPercentBadge = styled.div`
  padding: 1px 6px;
  border-radius: 4px;
  background: rgba(0, 138, 255, 0.06);
  color: #008aff;
  font-size: 12px;
  font-weight: 700;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;

const MinimumPriceText = styled(PriceText)`
  color: #008aff;
`;

const BidPriceText = styled(PriceText)`
  color: #f04452;
`;

const CourtName = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.64);
`;
const Block = styled.div<{
  flexDir: 'row' | 'column';
  paddingB?: number;
  borderB?: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: ${(props) => props.flexDir};
  align-items: ${(props) =>
    props.flexDir === 'row' ? 'center' : 'flex-start'};
  gap: 8px;
  padding-bottom: ${(props) => (props.paddingB ? `${props.paddingB}px` : '0')};
  border-bottom: ${(props) =>
    props.borderB ? '1px solid rgba(112, 115, 124, 0.16)' : 'none'};
  flex-wrap: wrap;
`;

const AddressBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
const JiBunAddressBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 2px;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 18px;
  font-weight: 700;
  color: #222;
`;
const JibunAddress = styled.div`
  flex: 1;
  flex-wrap: wrap;
`;
const CopyButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 500;
  color: #008aff;
  cursor: pointer;
`;
const RoadAddress = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #616161;
`;
const SaleDate = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;
const Divider = styled.div`
  width: 1px;
  height: 24px;
  background-color: rgba(112, 115, 124, 0.16);
`;
const BidInfoItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 400;
  color: #616161;
`;
const BidInfoContent = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #222;
`;
const PriceBox = styled.div`
  width: calc((100% - 8px) / 2);
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 400;
  line-height: 145%;
  color: #616161;
  border-radius: 8px;
  background-color: #f7f8fc;
`;
const Price = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #222;
`;
const InterestButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const InterestButton = styled.div`
  flex: 1;
  padding: 18px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
  cursor: pointer;
`;

const ViewCountBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  border-radius: 8px;
  padding: 12px;
  background-color: #f7f8fc;
`;

const ViewCount = styled.div`
  display: flex;
  flex: 1;
  gap: 2px;

  font-weight: 500;
  font-size: 13px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;

  span {
    font-weight: 400;
    font-size: 13px;
    line-height: 145%;
    letter-spacing: -2%;
    text-align: center;
    color: #616161;
  }
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const s = {
  Container,
  SimpleInfoBox,
  Dot,
  SimpleInfoText,
  SimpleInfoDivider,
  SummaryBox,
  SummaryDetail,
  ItemTypeChip,
  TitleArea,
  TitleAreaTop,
  TitleAreaTopButtonBox,
  ButtonIcon,
  Address,
  AddressDetail,
  CopyAddress,
  RowDivider,
  DetailArea,
  InfoArea,
  InfoList,
  Info,
  InfoText,
  InfoDateBox,
  DDayBadge,
  ChangeUnitButton,
  PriceArea,
  PriceText,
  MinimumPriceInfoText,
  MinimumPriceText,
  MinimumPercentBadge,
  PriceAreaInfoText,
  BidPriceInfoText,
  BidPriceText,

  CourtName,
  Block,
  AddressBox,
  JiBunAddressBox,
  JibunAddress,
  CopyButton,
  RoadAddress,
  SaleDate,
  Divider,
  BidInfoItem,
  BidInfoContent,
  PriceBox,
  Price,
  InterestButtonBox,
  InterestButton,
  ViewCountBox,
  ViewCount,
  Bottom,
};
